import React, { useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { Box, Grid, Divider } from '@material-ui/core';
import KenSelect from '../../global_components/KenSelect/index';
import {
  getcoursebyprogramplan,
  getProgramPlan,
  postNotification,
  getAcademicProgram,
  getInstituteDetails,
  postStorageDb,
} from '../../Utils/apiServices';
import KenInput from '../../global_components/KenInputField/index';
import KenButton from '../../global_components/KenButton/index';
import context from '../../Utils/context';
import KenCard from '../../global_components/KenCard';
import KenColors from '../../Utils/themes/KenColors';
import KenLoader from '../../Components/KenLoader/index';
import SmsAndMailSelection from '../../Components/SmsAndMailSelection';
import { Editor } from 'react-draft-wysiwyg';
import { EditorState, convertToRaw } from 'draft-js';
import { useTranslation } from 'react-i18next';

import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import draftToHtml from 'draftjs-to-html';
import { useSnackbar } from 'notistack';

const useStyles = makeStyles((theme) => ({
  formControlSelect: {
    margin: theme.spacing(1),
    minWidth: 220,
    border: '1px solid lightgray',
    borderRadius: 3,
  },
  FormControl: {
    width: 300,
    height: 200,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  outerContain: {
    width: '100%',
    height: ' 100%',
  },
  outerWrap: {
    margin: '0 auto',
  },
  mainLabel: {
    fontSize: 32,
    fontWeight: 'bold',
  },
  root: {
    width: '300px',
    // height: "220px",
    marginTop: '20px',
    marginDense: '20dense',
  },
  sendButton: {
    marginTop: 20,
  },
  inputField: {
    width: 346,
    paddingBottom: '40%',
    border: '1px solid lightgray',
    paddingTop: 10,
    paddingLeft: 10,
  },
  secondaryText: {
    fontSize: 14,
    color: theme.palette.KenColors.neutral900,
  },
  input: {
    width: '32%',
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
  },
  editorBox: {
    overflow: 'auto',
  },
  editorWrapper: {
    lineHeight: '1.4rem',
  },
}));

export default function Home() {
  const { handleSnackbarOpen, config } = React.useContext(context);

  const clientUid = config.clientUid;
  const classes = useStyles();
  let types = [
    {
      label: 'Institute',
      value: 'institute',
    },
    {
      label: 'Custom',
      value: 'custom',
    },
  ];

  const [editorState, setEditorState] = React.useState(() =>
    EditorState.createEmpty()
  );
  const { t } = useTranslation();

  const [loader, setLoader] = React.useState();
  const [Default, setDefault] = React.useState();
  const [audience, setAudience] = React.useState({ id: clientUid });

  const [typeValue, setTypeValues] = React.useState(types[0].value);

  const [linkUrl, setLinkUrl] = React.useState('');

  const [program, setProgram] = React.useState();
  const [programArray, setProgramArray] = React.useState();

  const [programPlan, setProgramPlan] = React.useState();
  const [programPlanArray, setProgramPlanArray] = React.useState();

  const [course, setCourse] = React.useState();
  const [courseArray, setCourseArray] = React.useState();

  const [heading, setHeading] = React.useState();
  const [content, setContent] = React.useState();

  const [instiId, setInstId] = React.useState();
  const [instiIdValue, setInstIdValue] = React.useState();

  const [custom, setCustom] = React.useState();

  const { enqueueSnackbar } = useSnackbar();

  React.useEffect(() => {
    
    if (!config) {
      setLoader(true);
    } else {
      setLoader(false);
    }
  }, []);

  const [customArr, setCustomArr] = React.useState([]);
  const [selectedType, setSelectedType] = React.useState(null);
  const [gradeWisePayload, setGradeWisePayload] = React.useState(null);

  const convertDraftToHtmlAndSetContent = async () => {
    const textContent = await draftToHtml(
      convertToRaw(editorState.getCurrentContent())
    );
    // await setContent(textContent);
    return textContent;
  };

  const onEditorStateChange = (editorState) => {
    setEditorState(editorState);
    convertDraftToHtmlAndSetContent();
  };

  const changeTypes = (e) => {
    const id = e.target.value;
    if (id === 'institute') {
      console.log('Predefined called', clientUid);
      setAudience({ Id: clientUid });
      setCustomArr([]);
      setCustom();
      setFormReset(true);
    } else if (id === 'custom') {
      console.log('do something');
    }
    setTypeValues(id);
  };

  const handleSubmit = async () => {
    setLoader(true);
    const getText = await convertDraftToHtmlAndSetContent();

    const id = audience.Id || audience.id;
    if (customArr?.length > 0) {
      customArr.forEach((el) => {
        const notification = {
          title: heading,
          body: content,
        };
        let body = {
          topic: `${clientUid}_${el}`,
          notification,
          data: {
            url: linkUrl,
            action: 'open-only',
          },
          // android: {
          //   notification,
          // },
          // webpush: {
          //   notification,
          // },
        };
        sendNotification(body);
        let storageBody = {
          collectionName: 'Notification',
          data: {
            channelId: `${clientUid}_${el}`,
            message: content,
            title: heading,
            source: 'portal',
          },
        };
        postStorageDb(storageBody)
          .then((res) => {
            console.log(res);
          })
          .catch((err) => {
            console.log(err);
            handleSnackbarOpen(
              'error',
              'Some Error occured while saving the data in Database'
            );
          });
      });
    } else {
      const notification = {
        title: heading,
        body: content,
      };
      let body = {
        topic: id,
        notification,
        data: {
          url: linkUrl,
          action: 'open-only',
        },
        // android: {
        //   notification,
        // },
        // webpush: {
        //   notification,
        // },
      };
      console.log(body);
      sendNotification(body);
      let storageBody = {
        collectionName: 'Notification',
        data: {
          channelId: id,
          message: content,
          title: heading,
          source: 'portal',
        },
      };
      postStorageDb(storageBody)
        .then((res) => {
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
          handleSnackbarOpen(
            'error',
            'Some Error occured while saving the data in Database'
          );
        });
    }
  };

  const arrayToString = (array = [], separator = ' || ') => {
    const prefix = clientUid;
    return array.length
      ? array
          .filter((e) => e && e !== 'All')
          .map((el) => `'${prefix}_${el}' in topics`)
          .join(separator)
      : '';
  };

  const buildCondition = () => {
    console.log('gradeWisePayload: ', gradeWisePayload);
    console.log('Options: ', allOptions);
    let condition = '';
    const topics = [];

    // If All institute, send to all institutes
    if (gradeWisePayload.institutes.includes('All')) {
      const institutes = allOptions?.institute?.map((el) => el.Id);
      condition += `(${arrayToString(institutes)})`;
      topics.push(...institutes);
    } else if (gradeWisePayload.departments.includes('All')) {
      // when all departments send institute
      condition += ` '${clientUid}_${gradeWisePayload.institutes[0]}' in topics`;
      topics.push(gradeWisePayload.institutes[0]);
    } else if (gradeWisePayload.classIds.includes('All')) {
      condition += `'${clientUid}_${gradeWisePayload.departments[0]}' in topics`;
      topics.push(gradeWisePayload.departments[0]);
    } else {
      console.log('clases: ', gradeWisePayload?.classIds);
      condition += ` (${arrayToString(gradeWisePayload?.classIds)})`;
      topics.push(...gradeWisePayload?.classIds);
    }
    // User type
    if (gradeWisePayload.types.includes('All')) {
      const grades = allOptions?.contactType?.map((el) => el.value);
      condition += ` && (${arrayToString(grades)})`;
      topics.push(...grades);
    } else {
      condition += ` && (${arrayToString(gradeWisePayload.types)})`;
      topics.push(...gradeWisePayload.types);
    }

    return { condition, topics: topics.filter((e) => e && e !== 'All') };
  };

  const sendNotification = (body) => {
    postNotification(body)
      .then((res) => {
        console.log(res);
        if (res?.status === false) {
          handleSnackbarOpen(
            'error',
            'Some Error occured while sending Notification'
          );
          setLoader(false);
        } else {
          handleSnackbarOpen('info', 'Notification Sent Successfully');
          resetForm();
          setLoader(false);
        }
      })
      .catch((err) => {
        console.log('error from change subProgram', err);
        handleSnackbarOpen(
          'error',
          'Something went wrong while sending notification'
        );
        setLoader(false);
      });
  };

  const handleCustom = (e) => {
    let value = e.target.value;
    setCustom(value);
    // const array = value.split(/,/);
    // const newArray = array.map((item) => {
    //   return item.trim();
    // });
    // newArray.forEach((item, index) => {
    //   if (item === '') {
    //     newArray.splice(index, 1);
    //   }
    // });
    // console.log(newArray);
    // setCustomArr(newArray);
  };

  const handleSelectType = async (value) => {
    await setSelectedType(value);
    console.log(value);
  };

  const handleGradeWiseDetails = (payload) => {
    console.log('handleGradeWiseDetails: ', payload);
    setGradeWisePayload(payload);
  };
  const [allOptions, setAllOption] = React.useState({});
  const handleAllOption = (options) => {
    console.log('OPtions: ', options);
    setAllOption(options);
  };

  const [isFormReset, setFormReset] = React.useState(true);
  const resetForm = () => {
    setFormReset(false);
    setTypeValues();
    setHeading('');
    setContent('');
    setLinkUrl('');
    setCustom('');
  };

  const handleSubmitNew = () => {
    let conditionData;
    if (typeValue === 'custom') {
      const customIdsArray = custom
        ?.trim()
        .split(',')
        .map((el) => el.trim())
        .filter((el) => el !== '');
      if (customIdsArray.length < 1) {
        enqueueSnackbar(t('messages:notification_topics_min_error'), {
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
          },
          variant: 'error',
        });
        return;
      }
      conditionData = {
        topics: customIdsArray,
        condition: customIdsArray.reduce((prev, current, idx) => {
          return idx === 0
            ? `'${clientUid}_${current}' in topics`
            : `${prev} || '${clientUid}_${current}' in topics`;
        }, ''),
      };
    } else {
      conditionData = buildCondition();
    }
    if (conditionData?.topics?.length > 5) {
      enqueueSnackbar(t('messages:notification_topics_error'), {
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'right',
        },
        variant: 'error',
      });
      return;
    }
    const condition = conditionData.condition;

    if (condition) {
      // Call api
      console.log(condition);

      const payload = {
        condition,
        notification: {
          title: heading,
          body: content,
        },
        data: {
          url: linkUrl,
          action: 'open-only',
        },
        isStored: true,
      };
      console.log('handleSubmitNew: ', payload);
      sendNotification(payload);
    } else {
      // Show error
    }
  };
  return (
    <KenCard>
      {loader && <KenLoader />}
      <div className={classes.outerContain}>
        <div className={classes.outerWrap}>
          <Typography className={classes.mainLabel}>Notifications</Typography>
          <Divider />

          <Box mt={2} mb={2}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={4} md={4}>
                <KenSelect
                  options={types}
                  defaultValue={typeValue}
                  value={typeValue}
                  onChange={changeTypes}
                  label={t('labels:select_type')}
                  required
                />
              </Grid>
            </Grid>
          </Box>

          {isFormReset && typeValue === 'institute' && (
            <SmsAndMailSelection
              typeValue={typeValue}
              handleSelectType={handleSelectType}
              handleGradeWiseDetails={handleGradeWiseDetails}
              handleAllOption={handleAllOption}
              type={1}
            />
          )}

          {typeValue === 'custom' && (
            <Box mt={2} mb={2}>
              <Box mt={1} mb={1} className={classes.input}>
                <KenInput
                  label="Custom ID's"
                  required
                  placeholder="Please use comma's to seperate ID's"
                  name="custom"
                  onChange={(e) => handleCustom(e)}
                  value={custom}
                />
              </Box>
            </Box>
          )}

          <Box mt={2} mb={2}>
            <Box mt={1} mb={1} className={classes.input}>
              <KenInput
                label={t('labels:Notification_Heading')}
                required
                name="heading"
                onChange={(e) => setHeading(e.target.value)}
                value={heading}
              />
            </Box>
            <Box mt={1} mb={1} className={classes.editorBox}>
              <KenInput
                multiline={true}
                label={t('labels:Notification_Content')}
                required
                onChange={(e) => setContent(e.target.value)}
                value={content}
                name="content"
              />
            </Box>

            <Box mt={1} mb={1} className={classes.editorBox}>
              <KenInput
                multiline={true}
                label={t('labels:link')}
                placeholder={t('messages:Provide_Url_Link')}
                required
                onChange={(e) => setLinkUrl(e.target.value)}
                value={linkUrl}
                name="content"
              />
            </Box>
          </Box>
          <Box display="flex" justifyContent="flex-end" pt={1} pb={1}>
            <Grid direction="row">
              <Grid mr={1}>
                <KenButton
                  variant="secondary"
                  label="Reset"
                  onClick={resetForm}
                  style={{ marginRight: 8 }}
                />
                <KenButton
                  variant="primary"
                  label="Submit"
                  onClick={handleSubmitNew}
                />
              </Grid>
            </Grid>
          </Box>
        </div>
      </div>
    </KenCard>
  );
}
